<template>
  <N2PaginaServicios v-if="disenoPropio" />
  <div v-else>
    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Servicios" type="servicios" />
    <!-- End Breadcrump Area  -->

    <!-- Start Service Area  -->
    <div class="rn-service-area rn-section-gap bg_color--1">
      <v-container>
        <ServiceNotinList :Home="false" type="servicios"/>
      </v-container>
    </div>
    <!-- Start Service Area  -->
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5: la página con el diseño de su portada (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2PaginaServicios from '../components/notaria2/N2PaginaServicios.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import feather from "feather-icons";
import { useStore } from '../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
const PageName = "Servicios"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
function iconSvg(icon) {
  return feather.icons[icon].toSvg();
}
</script>
